import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { FinalCustomerCard } from './FinalCustomerInput/components/FinalCustomerCard';
import { useFinalCustomerInput } from './hooks/useFinalCustomerInput';
import { CounterContainerService } from '../../views/Calendar/components/styles';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { Button } from '../buttons/buttons';

const ContainerCountServices = ({ selectedFinalCustomer }) => {
  const { translate: t } = useDictionaryTranslation();
  const { countServices } = useFinalCustomerInput(selectedFinalCustomer?._id);

  return (
    <Row gutter={15} style={{ marginTop: '1%' }}>
      <Col md={23}>
        <CounterContainerService>
          {t('finalCustomerCount')} <b>({countServices})</b> {t('finalCustomerCountText')}
        </CounterContainerService>
      </Col>
      <Col md={1}>
        <a href={`/final-customer/${selectedFinalCustomer?._id}/services`} target="__blank" rel="noopener noreferrer">
          <Button
            style={{ margin: '0px', padding: '0%'}}
            type="gray"
            size="large"
            icon={<EyeOutlined style={{ fontSize: '40px' }} />}
          />
        </a>
      </Col>
      <Col xs={24} md={24}>
        <FinalCustomerCard selectedCustomer={selectedFinalCustomer} />
      </Col>
    </Row>
  );
};

export default ContainerCountServices;

ContainerCountServices.propTypes = {
  selectedFinalCustomer: PropTypes.object,
};
